import _ from 'lodash';
import moment from 'moment';

class UninvoicedTimeEntryModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope) {
      "ngInject";
      this.name = 'ConfirmModal';

      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;

      $scope.filterrefresh = false;
      
      // Filter state
      $scope.uninvoicedFilter = {
        employee: "0",
        chargeCode: "0"
      };

      $scope.uninvoicedColumns = [
        {
          displayName: 'Date',
          value: 'date',
          sortable: true,
          sortValue: 'entryDate',
          dataType: 'text',
          formatting: function (record) {
            return moment(record.date).format("MMM DD YYYY");
          }
        },
        {
          displayName: 'Employee',
          value: 'employee',
          sortable: true,
          dataType: 'text',
          filterable: true,
          filterOptions: [],
          filterFunction: function(column) {
            const selectedEmployees = column.filterOptions.filter(function(opt) {
              return opt.selected && opt.id !== 0;
            });
            
            const allEmployeesOption = column.filterOptions.find(function(opt) {
              return opt.id === 0;
            });
            
            if(allEmployeesOption && allEmployeesOption.selected) {
              column.filterOptions.forEach(function(opt) {
                opt.selected = true;
              });
              $scope.uninvoicedFilter.employee = "0";
            } else if(selectedEmployees.length === 0) {
              if(allEmployeesOption) {
                allEmployeesOption.selected = false;
              }
              $scope.uninvoicedFilter.employee = "-1";
            } else if(selectedEmployees.length === column.filterOptions.length - 1) {
              if(allEmployeesOption) {
                allEmployeesOption.selected = true;
              }
              $scope.uninvoicedFilter.employee = "0";
            } else if(selectedEmployees.length === 1) {
              if(allEmployeesOption) {
                allEmployeesOption.selected = false;
              }
              $scope.uninvoicedFilter.employee = selectedEmployees[0].id.toString();
            } else {
              if(allEmployeesOption) {
                allEmployeesOption.selected = false;
              }
              const employeeIds = selectedEmployees.map(function(employee) {
                return employee.id.toString();
              });
              $scope.uninvoicedFilter.employee = employeeIds.join(',');
            }
            
            $scope.filterInvoices();
          }
        },
        {
          displayName: 'Charge Code',
          value: 'chargeCode.name',
          sortable: true,
          dataType: 'text',
          filterable: true,
          filterOptions: [],
          filterFunction: function(column) {
            const selectedChargeCodes = column.filterOptions.filter(function(opt) {
              return opt.selected && opt.id !== 0;
            });
            
            const allChargeCodesOption = column.filterOptions.find(function(opt) {
              return opt.id === 0;
            });
            
            if(allChargeCodesOption && allChargeCodesOption.selected) {
              column.filterOptions.forEach(function(opt) {
                opt.selected = true;
              });
              $scope.uninvoicedFilter.chargeCode = "0";
            } else if(selectedChargeCodes.length === 0) {
              if(allChargeCodesOption) {
                allChargeCodesOption.selected = false;
              }
              $scope.uninvoicedFilter.chargeCode = "-1";
            } else if(selectedChargeCodes.length === column.filterOptions.length - 1) {
              if(allChargeCodesOption) {
                allChargeCodesOption.selected = true;
              }
              $scope.uninvoicedFilter.chargeCode = "0";
            } else if(selectedChargeCodes.length === 1) {
              if(allChargeCodesOption) {
                allChargeCodesOption.selected = false;
              }
              $scope.uninvoicedFilter.chargeCode = selectedChargeCodes[0].id.toString();
            } else {
              if(allChargeCodesOption) {
                allChargeCodesOption.selected = false;
              }
              const chargeCodeIds = selectedChargeCodes.map(function(chargeCode) {
                return chargeCode.id.toString();
              });
              $scope.uninvoicedFilter.chargeCode = chargeCodeIds.join(',');
            }
            
            $scope.filterInvoices();
          }
        },
        {
          displayName: 'Hours',
          value: 'hours',
          sortable: true,
          dataType: 'text'
        }
      ];

      $scope.timeEntries = $uibModalInstance.timeEntries;
      $scope.tableData = [];
      
      // Watch for table data changes to populate filter options
      $scope.$watch('tableData', function(newData) {
        if(newData && newData.length > 0) {
          $scope.populateFilterOptions(newData);
        }
      }, true);
      
      // Function to populate filter options from data
      $scope.populateFilterOptions = function(data) {
        if(!data || !Array.isArray(data)) {
          return;
        }
        
        // Populate Employee filter options
        const employeeColumn = $scope.uninvoicedColumns.find(function(col) {
          return col.value === 'employee';
        });
        
        if(employeeColumn && employeeColumn.filterable) {
          const employeeMap = {};
          const employees = [];
          
          data.forEach(function(record) {
            if(record.employee && !employeeMap[record.employee]) {
              employeeMap[record.employee] = true;
              employees.push({
                id: record.employee,
                name: record.employee,
                label: record.employee
              });
            }
          });
          
          const currentEmployeeId = parseInt($scope.uninvoicedFilter.employee) || 0;
          const currentEmployeeIds = $scope.uninvoicedFilter.employee && $scope.uninvoicedFilter.employee !== "0" && $scope.uninvoicedFilter.employee !== "-1"
            ? $scope.uninvoicedFilter.employee.split(',').map(function(id) { return id.toString(); })
            : [];
          
          employeeColumn.filterOptions = [
            { id: 0, name: 'All Employees', label: 'All Employees', selected: currentEmployeeId === 0 }
          ].concat(employees.map(function(employee) {
            const isSelected = currentEmployeeId === 0 ||
                              currentEmployeeIds.indexOf(employee.id.toString()) !== -1 ||
                              currentEmployeeId.toString() === employee.id.toString();
            return {
              id: employee.id,
              name: employee.name,
              label: employee.label,
              selected: isSelected
            };
          }));
          
          const selectedCount = employeeColumn.filterOptions.filter(function(opt) {
            return opt.id !== 0 && opt.selected;
          }).length;
          const totalCount = employeeColumn.filterOptions.length - 1;
          employeeColumn.hasActiveFilter = selectedCount < totalCount;
          
          if(employeeColumn.hasActiveFilter && selectedCount > 0) {
            employeeColumn.filteredCount = selectedCount;
          } else {
            employeeColumn.filteredCount = null;
          }
        }
        
        // Populate Charge Code filter options
        const chargeCodeColumn = $scope.uninvoicedColumns.find(function(col) {
          return col.value === 'chargeCode.name';
        });
        
        if(chargeCodeColumn && chargeCodeColumn.filterable) {
          const chargeCodeMap = {};
          const chargeCodes = [];
          
          data.forEach(function(record) {
            if(record.chargeCode && record.chargeCode.name && !chargeCodeMap[record.chargeCode.name]) {
              chargeCodeMap[record.chargeCode.name] = true;
              chargeCodes.push({
                id: record.chargeCode.id || record.chargeCode.name,
                name: record.chargeCode.name,
                label: record.chargeCode.name
              });
            }
          });
          
          const currentChargeCodeId = parseInt($scope.uninvoicedFilter.chargeCode) || 0;
          const currentChargeCodeIds = $scope.uninvoicedFilter.chargeCode && $scope.uninvoicedFilter.chargeCode !== "0" && $scope.uninvoicedFilter.chargeCode !== "-1"
            ? $scope.uninvoicedFilter.chargeCode.split(',').map(function(id) { return id.toString(); })
            : [];
          
          chargeCodeColumn.filterOptions = [
            { id: 0, name: 'All Charge Codes', label: 'All Charge Codes', selected: currentChargeCodeId === 0 }
          ].concat(chargeCodes.map(function(chargeCode) {
            const isSelected = currentChargeCodeId === 0 ||
                              currentChargeCodeIds.indexOf(chargeCode.id.toString()) !== -1 ||
                              currentChargeCodeId.toString() === chargeCode.id.toString();
            return {
              id: chargeCode.id,
              name: chargeCode.name,
              label: chargeCode.label,
              selected: isSelected
            };
          }));
          
          const selectedCount = chargeCodeColumn.filterOptions.filter(function(opt) {
            return opt.id !== 0 && opt.selected;
          }).length;
          const totalCount = chargeCodeColumn.filterOptions.length - 1;
          chargeCodeColumn.hasActiveFilter = selectedCount < totalCount;
          
          if(chargeCodeColumn.hasActiveFilter && selectedCount > 0) {
            chargeCodeColumn.filteredCount = selectedCount;
          } else {
            chargeCodeColumn.filteredCount = null;
          }
        }
      };


      $scope.cancel = function () {
        $uibModalInstance.cancel();
      };

      $scope.getTotalHours = function() {
        let hours = 0;
        if($scope.timeEntries) {
          $scope.timeEntries.forEach((entry) => {
            hours += entry.hours;
          });
        }
        return hours;
      };


    $scope.filterCriteria = function () {
      let employeeParam = "employee=" + ($scope.uninvoicedFilter.employee || "0");
      let chargeCodeParam = "chargeCode=" + ($scope.uninvoicedFilter.chargeCode || "0");
      return employeeParam + "&" + chargeCodeParam;
    }

    $scope.filterInvoices = function (){
      $scope.filterrefresh = true;
    }


  }





}

export default UninvoicedTimeEntryModalController;



// WEBPACK FOOTER //
// ./client/common/modals/UninvoicedTimeEntryModal/uninvoicedTimeEntryModal.controller.js